import React from 'react'
import AdminSideBar from '../../Components/DashboardComponents/AdminSideBar'
import { Col, Row } from "react-bootstrap";
import NavBarDashboard from '../../Components/DashboardComponents/NavBarDashboard';
import Rate from '../../Components/RateManage/Rate';
const RateManagement = () => {
    return (
        <div>
            <Row className="py-3">
                <Col sm="5" xs="3" md="2" lg="2">
                    <AdminSideBar />
                </Col>
                <Col sm="7" xs="9" className='px-5' md="10" lg="10">
                    <NavBarDashboard />
                    <Rate />
                </Col>
            </Row>
        </div>
    )
}

export default RateManagement
